import styled from "styled-components";
import { Divider, Alert } from "antd";
import {
  PrimaryButtonComponent,
  GhostButtonComponent,DataValue
} from "../../../../../../CommonComponents/commonStyles";

export const ComponentDivider = styled(Divider)`
&&&
.ant-divider, 
  .ant-divider-horizontal{
     margin-top: ${props => props.marginTop};
     margin-bottom: ${props => props.marginBottom};
     background-color: #d4d4d4;
     @media only screen and (max-width: 576px) {
      margin-top: ${props => props.mt}; 
      margin-bottom: ${props => props.mb};
    }
}
`;

export const SectionLastHeading = styled.h1`
  font-family: BerkeleyStd-Book;
  font-size: ${props => props.fontSize};
  font-weight: normal;
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: 1.17;
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.headingColor};
  @media only screen and (max-width: 990px) {
    font-size: 36px;
    line-height: 1.17;
  }
  @media only screen and (max-width: 576px) {
    font-size:${props => props.mfSize}; 
    line-height: 1.17;
  }
`;

export const ContributionConfirmationSectionHeading = styled.h1`
  font-family: BerkeleyStd-Book;
  font-size: ${props => props.fontSize};
  font-weight: normal;
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: 1.17;
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.headingColor};
  @media only screen and (max-width: 990px) {
    font-size: 36px;
    line-height: 1.17;
  }
  @media only screen and (max-width: 576px) {
    font-size:${props => props.mfSize}; 
    line-height: 1.17;
  }
`;

export const ContributionConfirmationHeading = styled(ContributionConfirmationSectionHeading)`
margin-bottom: ${props => props.marginBottom};
margin-top: ${props => props.marginTop};
@media only screen and (min-width: 320px) and (max-width: 768px) {
  font-size: ${props => props.mfSize};
  margin-bottom: ${props => props.mb};
}
@media only print {
  margin-bottom: ${props => props.print ? '0' : props.marginBottom} !important;
  margin-top: ${props => props.print ? '50px' : props.marginTop};
}
`;

export const SectionHeading = styled(SectionLastHeading)`
margin-bottom: ${props => props.marginBottom};
margin-top: ${props => props.marginTop};
@media only screen and (min-width: 320px) and (max-width: 768px) {
  font-size: ${props => props.mfSize};
  margin-bottom: ${props => props.mb};
}
@media only print {
  margin-bottom: ${props => props.print ? '0' : props.marginBottom} !important;
  margin-top: ${props => props.print ? '50px' : props.marginTop};
}
`;

export const Disclaimer = styled.div`
font-family: HelveticaNeue;
font-size: 16px;
line-height: 1.5;
letter-spacing: 0.6px;
color: #505050;
margin-top: ${props => props.marginTop};
`;

export const Guildelines = styled.span`
text-decoration: underline;
color: #006778;
`;

export const ContribType = styled.span`
font-family: HelveticaNeue;
font-size: 16px;
color: #4a4a4a; 
`;

export const NavigationBtnContainer = styled.div`
  display:flex;
  & > button {
  margin-top: 20px;
  margin-right: 20px;
  }
  & > div {
    display: flex;    
  }
  @media only screen and (max-width: 991.92px) {
    flex-flow: wrap;
    & > button {
      flex-basis: 100%;
      margin-right: 0px;
      &:last-child {
        margin-top: 15px;
      }
    }
  }
`;

export const PrimaryNavigation = styled(PrimaryButtonComponent)`
  font-size: ${props => props.theme.fontSize.primary};
  width: ${props => props.width ? props.width : '150px'};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    width: ${props => props.mobHalfWidth ? "48%" : "100%"};
  }
`;

export const GhostNavigation = styled(GhostButtonComponent)`
width: ${props => props.width ? props.width : '150px'};
margin-right: 15px;
padding: 0 20px;
font-size: ${props => props.theme.fontSize.primary};
letter-spacing: ${props => props.theme.letterSpacing.normal};
@media only screen and (min-width: 320px) and (max-width: 991px) {
  width: ${props => props.mobHalfWidth ? "48%" : "100%"};
  margin-right: 0;
  &:last-child {
    margin-right: 0;
  }
}
`;

export const NoticeContent = styled.div`
justify-content: space-between !important;
align-items: center;
font-size: ${props => props.theme.fontSize.primary};
a {
  color: ${props => props.theme.colors.primaryColor};
  text-decoration: underline;
}
color: ${props => props.theme.fontColors.textColor};
@media only screen and (max-width: 991.92px) {
  flex-direction: column;
  font-size: ${props => props.theme.fontSize.secondary};
  justify-content: space-between !important;
  & > div:nth-child(1) {
    flex-basis: 75%;
    line-height: 1.67;
  }
  & > button {
    width: initial;
    align-self: flex-start;
  }
  width:100%;
}
`;

export const NoticeBorder = styled.div`
border-left: 6px solid ${props => props.theme.colors.info};
margin-bottom: 50px;
@media only screen and (min-width: 320px) and (max-width: 767px) {
  width: unset;
  border-left: none;
  border-top: 4px solid #e37222;
  margin-bottom: 40px;
}
`;

export const NoticeContainer = styled(Alert)`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  background-color: ${props => props.theme.backgroundColor.cardDark};
  border-radius: 0px;
  border: none;
  padding: 20px 30px!important;
  @media only screen and (max-width: 991.92px) {
    flex-direction: column;
    font-size: 14px;
    padding: 20px!important;
  }
`;

export const SubmitBold = styled.div`
 font-family: ${props => props.theme.fontFamily.helveticaNeueBold}; 
`;

export const IconsPlaceNew = styled.div`
  text-align: right;
  > span > button {
    padding-right: 30px;
  }
  @media (max-width: 576px) {
    > span > button {
      padding-right: 5px;
    }
  }
  @media (max-width: 990px) {
    text-align: initial;
    transform: initial;
  }
`;

export const IconPadding = styled.div`
  display: flex;
  justify-content: space-around;
  cursor: pointer;
  margin-right: ${props => (props.primary ? '50px' : '')};
  @media (max-width: 990px) {
    margin-left: 0px !important;
    margin-right: 20px;
  }
`;

export const DataExportPrint = styled(DataValue)`
  margin: 0px 5px;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.colors.primaryColor} !important;
  text-decoration: underline;
  display: block;
  :hover {
    color: ${props => props.theme.colors.primaryColor} !important;
    text-decoration: underline;
  }
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.primary};
    line-height: ${props => props.theme.lineHeight.primary};
  }
  @media only screen and (max-width: 576px) {
    font-size: 14px;
    line-height: ${props => props.theme.lineHeight.secondary};
  }
`;

export const EditButtonWrap = styled.div`
display: flex;
align-items: center;
`;

export const ConfirmDetails = styled.div`
  width: 67%;
  margin-bottom: 20px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    width: 100%;
  }
`;